export const getUserInfo = state => state.userInfo.data ? state.userInfo.data : {id: null};
export const getNicknameError = state => state.nicknameError;
